<div class="stat" [class.kpi-click]="clickable" (click)="clickable && clicked.emit()">
  <div class="n" [style.color]="valueColor || null">{{ value }}</div>
  <div class="l">{{ label }}</div>
</div>
